package com.fireavert.properties.property_details.client.presentation

import com.fireavert.common.Try
import com.fireavert.fire_risk.client.ClientTenantFireRiskRepository
import com.fireavert.logging.Logger
import com.fireavert.properties.archive_property.data_models.requests.ArchivePropertyRequest
import com.fireavert.properties.shared.client.ClientPropertyRepository
import com.fireavert.properties.shared.data_models.Mode
import com.fireavert.properties.shared.data_models.requests.PropertyModeChangeRequest
import com.fireavert.user.client.ClientUserRepository

class ClientPropertyDetails(
    private val propertyRepository: ClientPropertyRepository,
    private val clientUserRepository: ClientUserRepository,
    private val clientTenantFireRiskRepository: ClientTenantFireRiskRepository,
    private val screen: PropertyDetailsScreen,
    private val logger: Logger
) : PropertyDetails {
    override suspend fun onLoad(propertyId: Int, userId: Int) {
        screen.setLoadingStatus(true)
        when (val maybeProperty = propertyRepository.getPropertyByIdAsync(propertyId)) {
            is Try.Success -> {
                screen.setPropertyName(maybeProperty.value.name)
                screen.setPropertyTotalUnits(maybeProperty.value.units)
                screen.setPropertyMode(maybeProperty.value.mode)
                screen.setPmsType(maybeProperty.value.pmsType)
                screen.setPropertyDefaultStoveCookingTimeMinutes(
                    maybeProperty.value.defaultStoveCookingTimeMinutes
                )
            }
            is Try.Error -> {
                //TODO() handle this error
                logger.e("Failed ot get Property by id $propertyId")
                screen.setLoadingStatus(false)
            }
        }
        when (val maybe = clientUserRepository.userAdminCheck(userId)) {
            is Try.Success -> {
                screen.setIdAdmin(maybe.value)
            }
            is Try.Error -> {
                //TODO() handle this error
                logger.e("Failed to check if user is admin")
                screen.setLoadingStatus(false)
            }
        }

        screen.setLoadingStatus(false)
    }

    override suspend fun turnOnTestMode(propertyId: Int, mode: Mode, duration: Int) {
        val request = PropertyModeChangeRequest(propertyId, mode, duration)
        return when (propertyRepository.updatePropertyMode(request)) {
            is Try.Success -> {
                screen.closeTestModeDialog(true)
            }
            is Try.Error -> {
                screen.setTestModeError("Failed to set the property to test mode, please try again.")
            }
        }
    }

    override suspend fun archiveProperty(propertyId: Int, password: String): Boolean {
        val request = ArchivePropertyRequest(propertyId, password)
        return when (propertyRepository.archiveProperty(request)) {
            is Try.Success -> {
                true
            }
            is Try.Error -> {
                false
            }
        }
    }
}